export const firebaseConfig = {
    apiKey: 'AIzaSyDoucbxmDrfLTpm2ewd6j9EdLhKso3crXc',
    authDomain: 'affable-tribute-275721.firebaseapp.com',
    databaseURL: 'https://affable-tribute-275721.firebaseio.com',
    projectId: 'affable-tribute-275721',
    storageBucket: 'affable-tribute-275721.appspot.com',
    messagingSenderId: '791497714345',
    appId: '1:791497714345:web:d6e1ad73952043989597b8',
};
